import { useRoute } from '@lp/features/RoutePlanner/hooks/useRoute';
import { useConvertedRoute } from '@lp/features/RoutePlanner/hooks/useConvertedRoute';
import { RouteTypeEnum } from '@/api/apis/route';
import { Case } from '@/api/apis/case';
import { RouteFilterType } from '@/types/route';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { RouteSegmentsList } from './RouteSegmentsList';

type RouteListProps = {
  routeType: RouteTypeEnum;
  filterType: RouteFilterType;
  donorHospitalDateTimeString: string | null;
  recipientHospitalDateTimeString?: string | null;
  donorOperationEndDateTimeString?: string | null;
  recipientOperationEndDateTimeString?: string | null;
};

export const RouteList = ({
  routeType,
  filterType,
  donorHospitalDateTimeString,
  recipientHospitalDateTimeString,
  donorOperationEndDateTimeString,
  recipientOperationEndDateTimeString,
}: RouteListProps) => {
  const { donorHospitalDetails: donorHospital, txCenterDetails: txCenter } = useBaseCaseDetails() as Case;
  const { segments, legs, accommodationLegs } = useConvertedRoute({
    routeType,
    filterType,
    donorHospital: donorHospital!,
    txCenter,
    donorHospitalDateTimeString,
    recipientHospitalDateTimeString,
    donorOperationEndDateTimeString,
    recipientOperationEndDateTimeString,
  });
  const { handleHubModalOpen, handleOpenNewLegModal, handleRemoveHub, handleEditLegModalOpen } = useRoute({
    routeType,
    donorHospital: donorHospital!,
    txCenter,
    filterType,
    segments,
    legs,
  });

  return (
    <div className="relative py-2">
      <RouteSegmentsList
        routeType={routeType}
        filterType={filterType}
        legs={legs}
        accommodationLegs={accommodationLegs}
        segments={segments}
        handleAddNewLeg={handleOpenNewLegModal}
        handleHubAssign={handleHubModalOpen}
        handleRemoveHub={handleRemoveHub}
        handleLegInfoClick={handleEditLegModalOpen}
      />
    </div>
  );
};
